import $ from 'jquery';
export const openSeries = async (ctx) => {
    const { newOrderModel, showAlert } = ctx.props;
    if (newOrderModel.SerieArray.length === 0) {
        showAlert({ type: 'info', message: 'No hay Información por mostrar' });
        return;
    }

    setTimeout(() => {
        ctx.setState({
            series: newOrderModel.SerieArray,
        });
        $('#seriesDocumentsModal').modal('show');
    }, 100);
};

export const selectSeries = (ctx,action) => {
        const { newOrderModel, refreshModel } = ctx.props;
        let serie = newOrderModel.SerieArray[action.index];
        newOrderModel.SerieName = serie.SeriesName || '';
        newOrderModel.SerieCode = serie.Series || '';
        newOrderModel.NextFolio = serie.NextNumber || '';


        refreshModel(newOrderModel);
        $('#seriesDocumentsModal').modal('hide');
        setTimeout(() => {
            ctx.setState({
                series: [],
            });
        }, 100);
    };